var map = {
	"./buttonhole/en.md": 46778,
	"./cable-sweater/en.md": 79537,
	"./embroidered-sweater/en.md": 3402,
	"./felted-mittens/en.md": 29,
	"./leftover-beanie/en.md": 57721,
	"./leftover-sweater/en.md": 61118,
	"./patterned-mittens/en.md": 57243,
	"./we-re-in-laine/en.md": 55166,
	"./what-could-i-knit-with-this-yarn/en.md": 25090
};

function webpackAsyncContext(req) {
	return Promise.resolve().then(function() {
		if(!__webpack_require__.o(map, req)) {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		}

		var id = map[req];
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 72748;
module.exports = webpackAsyncContext;